var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sectionarray",
      class: _vm.input.extraClass,
      style: _vm.input.style,
    },
    [
      _c(
        "div",
        { staticClass: "headline" },
        [
          _c("span", { on: { click: _vm.toggleOpenOuter } }, [
            _vm._v(_vm._s(_vm.input.label)),
          ]),
          _vm.outerToggleIsClosed
            ? _c("span", {
                staticClass: "toggleOpenRightArrow",
                on: { click: _vm.toggleOpenOuter },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.input.helper
            ? _c("HelperBox", { attrs: { text: _vm.input.helper } })
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "toggleOpenFloat",
            class: { closed: _vm.outerToggleIsClosed },
            attrs: { title: "open / close" },
            on: { click: _vm.toggleOpenOuter },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.input.description
        ? _c("div", { staticClass: "description" }, [
            _c("small", [_vm._v(_vm._s(_vm.input.description))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.outerToggleIsClosed
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "sortable",
                  rawName: "v-sortable",
                  value: _vm.sortOptions,
                  expression: "sortOptions",
                },
              ],
              staticClass: "sort-list",
            },
            [
              _vm._l(
                _vm.getNestedValue(_vm.formValue, _vm.input.value),
                function (sectionValue, index) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "inner closed",
                        class: _vm.input.grid,
                        attrs: { "data-sort": index, "data-id": _vm.arrayId },
                        on: {
                          focusin: function ($event) {
                            return _vm.toggleOpen(
                              $event,
                              _vm.arrayId,
                              index,
                              true
                            )
                          },
                          dblclick: function ($event) {
                            return _vm.toggleOpen($event, _vm.arrayId, index)
                          },
                        },
                      },
                      [
                        _vm.showHideIcon(_vm.input)
                          ? _c("div", {
                              staticClass: "toggleOpen",
                              attrs: { title: "open / close" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleOpen(
                                    $event,
                                    _vm.arrayId,
                                    index
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "numpadding" }, [
                          _c("span", { staticClass: "number" }, [
                            _vm._v(_vm._s(index + 1)),
                          ]),
                          _vm._v(" "),
                          (
                            !_vm.input.disableDelete
                              ? true
                              : !_vm.input.disableDelete
                          )
                            ? _c("span", {
                                staticClass: "delete",
                                on: {
                                  click: function ($event) {
                                    return _vm.onArrayItemDelete(
                                      $event,
                                      sectionValue,
                                      _vm.formValue,
                                      _vm.input.value
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.input.forms,
                          function (sectionInput, index2) {
                            return [
                              sectionInput &&
                              (_vm.isOpen(_vm.arrayId, index) || index2 < 3)
                                ? [
                                    sectionInput.type === "section"
                                      ? [
                                          _c("Section", {
                                            attrs: {
                                              input: sectionInput,
                                              formValue: sectionValue,
                                            },
                                          }),
                                        ]
                                      : sectionInput.type === "sectionarray"
                                      ? [
                                          _c("SectionArray", {
                                            attrs: {
                                              input: sectionInput,
                                              formValue: sectionValue,
                                            },
                                          }),
                                        ]
                                      : sectionInput.type === "sectionpicker"
                                      ? [
                                          _c("SectionPicker", {
                                            attrs: {
                                              input: sectionInput,
                                              formValue: sectionValue,
                                            },
                                          }),
                                        ]
                                      : sectionInput.type === "aggregationtable"
                                      ? [
                                          _c("AggregationTable", {
                                            attrs: {
                                              input: sectionInput,
                                              formValue: sectionValue,
                                            },
                                          }),
                                        ]
                                      : [
                                          _c("InputField", {
                                            attrs: {
                                              input: sectionInput,
                                              formValue: sectionValue,
                                            },
                                          }),
                                        ],
                                  ]
                                : _vm._e(),
                            ]
                          }
                        ),
                      ],
                      2
                    ),
                  ]
                }
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.outerToggleIsClosed &&
      typeof _vm.input.buttonText != "undefined" &&
      _vm.input.buttonText != null &&
      _vm.input.buttonText != ""
        ? _c(
            "button",
            {
              staticClass: "right",
              on: {
                click: function ($event) {
                  return _vm.onSectionArrayButtonClick($event, _vm.input)
                },
              },
            },
            [_vm._v(_vm._s(_vm.input.buttonText) + "\n  ")]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }